<template>
  <div class="container">
    <div class="content">
      <p class="heading horizontal-padding">
        <span class="line-green">機種変更の時に便利！</span><br>
        <span class="line-green">LINEアカウント連携</span> をご利用ください
      </p>
      <p class="horizontal-padding" style="margin-bottom: 0">
        LINEアカウント連携はお使いのLINEアカウントと香の川製麺アプリのアカウントを連携することができる機能です。<br>
        事前にLINEアカウント連携をしておくと、機種変更時の引き継ぎでデータを簡単に引き継ぐことができます。
      </p>
      <img :src="require('@/assets/img/line-login/line-login.png')" class="horizontal-padding" style="width: 100%" />
      <div v-if="!isLoggedIn">
        <img :src="require('@/assets/img/line-login/line-login-button.png')" class="horizontal-padding" style="width: 100%" @click="this.tapLineLogin" />
        <p class="horizontal-padding" style="text-align: left; margin-top: 12px; color: #666">※LINEアカウント連携機能はアプリバージョン4.2.0以上対応です。</p>
      </div>
      <span v-else>
        <div class="line-logged-in">
          <img :src="require('@/assets/img/line-login/icon-chain.png')" style="width: 16px; margin-right: 6px" />
          LINEアカウント連携済み
        </div>
        <div class="horizontal-padding">
          <button class="revoke" @click="this.tapRevokeLineLogin">LINEアカウント連携を解除する</button>
        </div>
      </span>
      <p class="horizontal-padding" style="margin-top: 30px">
        <span style="font-weight: bold">●ご注意事項</span><br>
        ・LINEアカウントをお持ちでない方はご利用できません。<br>
        ・1つのアプリIDに対して、同時に連携できるLINEアカウントは1つまでです。<br>
        ・機種変更時にLINEログインでデータ引き継ぎができるのは、機種変更前に香の川製麺アプリとLINEアカウントを連携している場合のみになります。<br>
        ・LINEアカウントを変更したい方は、接続しているLINEアカウントを解除の上、連携し直してください。<br>
        ・ID連携をしないまま、引き継ぎページから引き継ぎボタンを押しても引き継ぎはできません。新しいアプリIDとお手持ちのLINE IDが連携されます。
      </p>
    </div>
    <template v-if="isAlert">
      <alert-primary-secondary
        :title="'LINEアカウント連携を<br>解除してよろしいですか？'"
        :primaryLabel="'解除する'"
        :secondaryLabel="'戻る'"
        @tapPrimary="() => executeRevoke()"
        @tapSecondary="() => closeConfirmAlert()"
      />
    </template>
    <template v-if="isCompleteAlert">
      <alert-primary-secondary
        :title="'連携を解除しました'"
        :secondaryLabel="'閉じる'"
        @tapSecondary="() => closeCompleteAlert()"
      />
    </template>
    <VersionCheck :msg="'LINE アカウント連携機能はアプリバージョン4.2.0以上対応です。<br />最新版のアプリにアップデートしてください。'" :show="this.versionCheckAlert" :on-close="closeVersionCheckAlert" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import APIClient, { ErrorCode } from '@/api/APIClient'
import DateFormatter from '../utils/DateFormatter'
import AlertPrimarySecondary from '@/components/Modal/AlertPrimarySecondary.vue'
import VersionCheck from './FAQWalkVersionCheck'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'DataInheritInput',
  components: {
    AlertPrimarySecondary,
    VersionCheck
  },
  data: function() {
    return {
      isLoggedIn: false,
      isAlert: false,
      isCompleteAlert: false,
      versionCheckAlert: false
    }
  },
  created() {
    document.title = 'LINEアカウント連携とは'

    const accTime = new DateFormatter().format(new Date())
    const params = {
      apiType: '12',
      acc_time: accTime
    }
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchUserLine(json)
        window.receivedToken = null
      }
      this.actionRequestToken(params)
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedLineAccessToken = async payload => {
        const json = JSON.parse(payload)
        this.actionToggleLoading(true)
        const res = await APIClient.postLineLogin(json.app_token, json.acc_time, json.user_id, json.line_access_token)
        this.actionToggleLoading(false)
        let result = ''
        console.log(res)
        if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
          this.isLoggedIn = true
        } else if (res.status === 200 && res.data.data.code === '4003000') {
          result = 'このLINEアカウントはすでに別のアプリIDと連携されています。\n' +
            'アプリを再インストールして引き継ぎ画面より、LINE連携でアプリを開始してください。'
        } else {
          result = 'LINE アカウント連携に失敗しました'
        }
        this.actionLineLoginResult(result)
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', ['actionRequestToken', 'actionRequestLineLogin', 'actionLineLoginResult', 'actionVer4_2']),
    ...mapActions('Analytics', ['trackEvent']),
    async tapLineLogin() {
      this.trackEvent(FactoryTrack.createLineLogin())
      this.versionCheckAlert = await this.actionVer4_2()
      if (this.versionCheckAlert === 0) {
        await this.actionRequestLineLogin()
      }
    },
    async tapRevokeLineLogin() {
      this.trackEvent(FactoryTrack.createRevokeLineLoginOpen())
      this.versionCheckAlert = await this.actionVer4_2()
      if (this.versionCheckAlert === 0) {
        this.isAlert = true
      }
    },
    async fetchUserLine(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time
      const res = await APIClient.postFetchUserLine(token, accTime, userId)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS && res.data.data.user_id.length > 0) {
        this.isLoggedIn = true
      }
    },
    async revokeUserLine(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time
      this.actionToggleLoading(true)
      const res = await APIClient.postRevokeUserLine(token, accTime, userId)
      if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        this.isLoggedIn = false
        this.isCompleteAlert = true
      }
      this.actionToggleLoading(false)
    },
    executeRevoke() {
      this.trackEvent(FactoryTrack.createRevokeLineLogin())
      this.isAlert = false
      const accTime = new DateFormatter().format(new Date())
      const params = {
        apiType: '12',
        acc_time: accTime
      }

      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.revokeUserLine(json)
          window.receivedToken = null
        }
        this.actionRequestToken(params)
      } catch (e) {
        console.log(e)
      }
    },
    closeConfirmAlert() {
      this.trackEvent(FactoryTrack.createRevokeLineLoginClose())
      this.isAlert = false
    },
    closeCompleteAlert() {
      this.trackEvent(FactoryTrack.createCompleteRevokeLineLoginClose())
      this.isCompleteAlert = false
    },
    closeVersionCheckAlert() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.versionCheckAlert = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  .content {
    padding: 30px 0;

    p {
      text-align: left;
      color: #333333;
      font-size: 14px;
      margin-bottom: 30px;
    }

    .heading {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    .horizontal-padding {
      padding: 0 30px;
    }

    .line-logged-in {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      background: #fceaea;
      color: #E03535;
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.line-green {
  color: #1DC321;
}

button.revoke {
  width: 100%;
  background: #1DC321;
  border-radius: 7px;
  border: none;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  padding: 13px 2px;
  margin-top: 20px;
}
</style>
